import BaseService from '../BaseService'
import axios from "axios";

class EmailService extends BaseService {
    constructor() {
        super('/emails');
    }

    sendTestEmail({payload}) {
        return axios.post(`api/v1/send-test-email`, payload)
    }

    campaignTemplates({query = ''}) {
        const q = query.length > 0 ? `?${query}` : ''
        return axios.get(`api/v1/campaign-templates${q}`)
    }

    update ({ id, payload }) {
        return axios.post(`${this.resource}/${id}`, payload)
    }
}

export default new EmailService()
